import { Outlet, useMatch } from 'react-router';
import { ConversationList } from './ConversationList';
import { InboxFilters } from './InboxFilters';
import { LiveBridge } from './LiveBridge';
import { NightSuggestion } from './NightSuggestion';
import styles from './InboxPage.module.css';
import { Rail } from './Rail';

export function InboxPage() {
  // En pantalla estrecha se ve la lista o el hilo, no los dos.
  const open = useMatch('/conversaciones/:id') !== null;

  return (
    <div className={styles.app} data-open={open}>
      <Rail />
      <nav className={styles.list} aria-label="Bandeja">
        <InboxFilters />
        <ConversationList />
      </nav>
      <main className={styles.pane}>
        <Outlet />
      </main>
      <NightSuggestion />
      <LiveBridge />
    </div>
  );
}
